module.exports = __webpack_public_path__ + "./images/24b9580b6e22bbaeed08890722ba2937.webp";